import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getCityNemsisCode, ILocationNemsisLookupData, ILocationInfo } from './getCityNemsisCode.saga'
import { getLocationSearchState } from '../selectors'
import { ILocationSearchState } from '../store/locationSearch.types'
import { LocationSearchConstants } from '../store/locationSearch.constants'
import { DestinationAddressConstants } from '../../destinationAddress/store/destinationAddress.constants'
import { getDestinationAddressSelector } from '../../destinationAddress/selectors/destinationAddress.selectors'
import { IDispositionState } from '../../destinationAddress/store/destinationAddress.types'
import { setCity } from '../../destinationAddress/store/destinationAddress.actions'
import { setErrorInfo } from '../store/locationSearch.actions'
import Logger from '../../../services/logger.service'
import { ICity } from '../../../common/common.types'
import { areObjectsEqual } from '../../../utilities/object.util'

export function* setRecCityNemsisCode() {
  const { errorMsgsMap }: ILocationSearchState = yield select(getLocationSearchState)
  const { destination }: IDispositionState = yield select(getDestinationAddressSelector)
  const { city, state, county } = destination
  const locationInfo: ILocationInfo = { city, state, county }
  try {
    if (city) {
      const nemsisData: ILocationNemsisLookupData = yield call(getCityNemsisCode, locationInfo)
      const updatedCity: ICity = { ...city, nemsisCode: nemsisData.city?.nemsisCode || '' }
      errorMsgsMap[DestinationAddressConstants.SET_CITY] = nemsisData.cityError
      errorMsgsMap[DestinationAddressConstants.SET_STATE] = nemsisData.stateError
      errorMsgsMap[DestinationAddressConstants.SET_COUNTY] = nemsisData.countyError
      if (areObjectsEqual(city, updatedCity)) {
        return
      }
      yield put(setCity(updatedCity))
      yield put(setErrorInfo(errorMsgsMap))
    }
  } catch (e) {
    Logger.error(`Error getRecCityNemsisCode', ${e}`)
  }
}

export function* setRecCityNemsisCodeSaga() {
  yield takeLatest(
    [
      LocationSearchConstants.GET_REC_CITY_NEMSIS_CODE,
      DestinationAddressConstants.SET_DISPOSITION_STATE,
      DestinationAddressConstants.SET_COUNTY,
      DestinationAddressConstants.SET_STATE,
    ],
    setRecCityNemsisCode
  )
}
